import React, {PureComponent} from "react"
import {injectIntl} from "@irati/utils/lang"
import customRewardImage from "@irati-web/reward/src/images/customReward.png"

import ItemTemplate from "./ItemTemplate"

interface Props {
  redemption: RewardRedemption,
  openPopUp(event:any): void
}

class MyRewardsItem extends PureComponent<Props> {
  handleClick = () => {
    const {redemption, openPopUp} = this.props
    openPopUp(redemption)
  }

  render() {
    const {rewardOrder, custom, createdAt} = this.props.redemption
    const {reward, product} = rewardOrder

    if (custom) {
      return (
        <ItemTemplate
          handleClick={this.handleClick}
          imageSrc={customRewardImage}
          title={custom}
          createdAt={createdAt} />
      )
    }

    return (
      <ItemTemplate
        handleClick={this.handleClick}
        imageSrc={reward.thumbnailImage}
        title={reward.header}
        subTitle={product.name}
        createdAt={createdAt} />
    )
  }
}

export default injectIntl(MyRewardsItem)
